import { RootState } from '../../store';

export const selectLabRequests = (state: RootState) => state.auditTrail.list;

export const selectListError = (state: RootState) => state.auditTrail.listError;

export const selectCurrentLabRequest = (state: RootState) => state.auditTrail.current;

export const selectCurrentError = (state: RootState) => state.auditTrail.currentError;

export const selectLoading = (state: RootState) => state.auditTrail.loading;

export const selectCreateAuditTrailOpened = (state: RootState) => state.auditTrail.createEventOpen;

export const selectCreatingNewEvent = (state: RootState) => state.auditTrail.creatingNewEvent;

export const selectCreateEventError = (state: RootState) => state.auditTrail.createEventError;

export const selectCreateEventData = (state: RootState) => state.auditTrail.createEventData;

export const selectNewEvent = (state: RootState) => state.auditTrail.newEvent;

export const selectFilters = (state: RootState) => state.auditTrail.filters;

export const selectPaging = (state: RootState) => state.auditTrail.paging;
